const data = {
  clientName: "Client Name Here",
  url: "https://client-domain.com",
  date: new Date().toLocaleDateString(), // Auto-generate today's date

  executive: {
    performance: {
      score: 85, // Lighthouse "Performance" score (0-100)
      grade: "Good", // Good / Watch / Fix
      note: "Based on Lighthouse performance score",
    },
    seo: {
      score: 92, // Lighthouse "SEO" score (0-100)
      grade: "Good",
      note: "Based on Lighthouse SEO score",
    },
    accessibility: {
      score: 88, // Lighthouse "Accessibility" score (0-100)
      grade: "B",
      note: "Based on Lighthouse accessibility score",
    },
    bestPractices: {
      score: 90, // Lighthouse "Best Practices" score (0-100)
      grade: "Good",
      note: "Based on Lighthouse best practices score",
    },
    mobile: {
      grade: "Watch",
      note: "Check Mobile-Friendly Test for more info",
    },
    security: {
      grade: "B",
      note: "Run SSL Labs & SecurityHeaders.com for full details",
    },
    webVitals: {
      passRate: "3/5",
      note: "See LCP, INP, CLS details below",
    },
  },

  vitals: {
    lcp: {
      value: 2.3, // Lighthouse "LCP" (Largest Contentful Paint) value in seconds
      target: 2.5,
      unit: "s",
    },
    inp: {
      value: 180, // Lighthouse "INP" (Interaction to Next Paint) in ms
      target: 200,
      unit: "ms",
    },
    cls: {
      value: 0.05, // Lighthouse "CLS" (Cumulative Layout Shift)
      target: 0.1,
      unit: "",
    },
  },

  quickWins: [
    { priority: "High", task: "Compress and lazy-load hero images", impact: "High" },
    { priority: "High", task: "Reduce unused JavaScript/CSS", impact: "High" },
    { priority: "Medium", task: "Minify and inline critical CSS", impact: "Medium" },
    { priority: "Medium", task: "Add meta description tag", impact: "Medium" },
    { priority: "Low", task: "Improve CTA contrast & placement", impact: "Low" },
  ],

  severity: {
    critical: 1,
    high: 2,
    medium: 3,
    low: 2,
  },

  roi: [
    "Improved performance boosts conversion rates.",
    "Better SEO ranking increases organic traffic.",
    "Accessibility compliance enhances user experience and trust.",
  ],

  whyItMatters: [
    "Faster websites rank better and have lower bounce rates.",
    "Fixing SEO issues improves discoverability.",
    "Accessibility and security build trust with customers.",
  ],
};

export default data;
